import { load } from '../Actions/Cart.action';
import { post, get, patch } from './http';
import { translate } from './translation';

export const WISHLIST_UPDATE_WISHLIST_NAME = 'WISHLIST_UPDATE_WISHLIST_NAME';
export const WISHLIST_ADD_TO_CART = 'WISHLIST_ADD_TO_CART';
export const WISHLIST_ADD_ALL_TO_CART = 'WISHLIST_ADD_ALL_TO_CART';
export const WISHLIST_GET = 'WISHLIST_GET';
export const WISHLIST_GET_ALL = 'WISHLIST_GET_ALL';
export const WISHLIST_DELETE = 'WISHLIST_DELETE';
export const WISHLIST_DELETE_ITEM = 'WISHLIST_DELETE_ITEM';
export const REMOVE_ERROR = 'REMOVE_ERROR';

export const add = async (wishlistName, articleNumber, quantity = 1) => {
    const response = await post('/api/wishlist/add', {
        wishlistName: wishlistName || 'Default',
        articleNumber: articleNumber,
        quantity: parseInt(quantity),
    });
    return response.json();
};

export const updateWishListName = (previousName, newName) => (dispatch) => {
    return patch('/api/wishlist/wishlistname', {
        previousName: previousName,
        newName: newName,
    })
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_UPDATE_WISHLIST_NAME,
                payload: {
                    success: true,
                    message: translate('wishlist.update.success'),
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_UPDATE_WISHLIST_NAME,
                payload: {
                    success: false,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const addToCart = (articleNumber, quantity) => (dispatch) => {
    return post('/api/wishlist/addtocart', {
        articleNumber: articleNumber,
        quantity: parseInt(quantity),
    })
        .then(() => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    addToCart: {
                        success: true,
                        message: translate('wishlist.addtocart.success'),
                    },
                },
            });
        })
        .finally(() => {
            dispatch(load());
            setTimeout(() => {
                dispatch({
                    type: REMOVE_ERROR,
                    payload: {
                        success: true,
                    },
                });
            }, 3000);
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    success: false,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const addAllToCart = (wishlistName) => (dispatch) => {
    return post('/api/wishlist/addalltocart', {
        wishlistName: wishlistName,
    })
        .then(() => {
            dispatch({
                type: WISHLIST_ADD_ALL_TO_CART,
                payload: {
                    addAllToCart: {
                        success: true,
                        message: translate('wishlist.addalltocart.success'),
                    },
                },
            });
        })
        .finally(() => {
            dispatch(load());
            setTimeout(() => {
                dispatch({
                    type: REMOVE_ERROR,
                    payload: {
                        success: true,
                    },
                });
            }, 3000);
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_ADD_ALL_TO_CART,
                payload: {
                    success: false,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const getWishlist = (wishlistName) => (dispatch) => {
    return get(`/api/wishlist/getwishlist/${wishlistName}`, {
        wishlistName: wishlistName,
    })
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_GET,
                payload: {
                    success: true,
                    message: 'Successfull fetch',
                    list: result,
                },
                result,
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_GET,
                payload: {
                    success: false,
                    error: ex,
                    message: 'There was an error',
                },
            });
        });
};

export const getAllWishlists = () => (dispatch) => {
    return get('/api/wishlist/getallwishlists')
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_GET_ALL,
                payload: {
                    success: true,
                    message: 'Successfull fetch',
                    lists: result,
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_GET_ALL,
                payload: {
                    success: false,
                    error: ex,
                    message: 'There was an error',
                },
            });
        });
};

export const deleteWishList = (wishlistName) => (dispatch) => {
    return post('/api/wishlist/deletelist', {
        wishlistName: wishlistName,
    })
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_DELETE,
                payload: {
                    success: true,
                    message: translate('wishlist.delete.success'),
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_DELETE,
                payload: {
                    success: false,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const deleteWishListItem = (sortIndex, wishlistName) => (dispatch) => {
    return post('/api/wishlist/deletelistitem', {
        sortIndex: sortIndex,
        wishlistName: wishlistName,
    })
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_DELETE_ITEM,
                payload: {
                    success: true,
                    message: translate('wishlist.delete.success'),
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_DELETE_ITEM,
                payload: {
                    success: false,
                    message: translate('wishlist.error'),
                },
            });
        });
};
